import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de';
import 'flatpickr/dist/flatpickr.css';

function disableRestDays(date) {
  return (date.getDay() === 1 || date.getDay() === 2);
}

const fp = flatpickr(document.querySelector('input.widget-datepicker'), {
  minDate: 'today',
  dateFormat: 'd.m.Y',
  altInput: true,
  altFormat: 'j. F Y',
  defaultDate: new Date(),
  disable: [
    disableRestDays,
    {
      from: '24.12.2021',
      to: '25.12.2021',
    },
    {
      from: '31.12.2021',
      to: '06.01.2022',
    },
  ],
  locale: German,
});

export default fp;
